import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "./utils/axiosConfig";
import { useAuth0 } from "@auth0/auth0-react";
import ProtectedAndOnboarded from "./features/auth/ProtectedAndOnboarded";
import { setTokenGetter } from "./utils/authToken";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Login from "./features/auth/Login";
import GuestOnly from "./features/auth/GuestOnly";
import Register from "./features/auth/Register";
import ProtectedRoute from "./features/auth/ProtectedRoute";
import RegisterData from "./features/auth/RegisterData";
import AccountLink from "./features/auth/AccountLink.js";
import AccountLinkComplete from "./features/auth/AccountLinkComplete.js";
import EmailVerified from "./features/auth/EmailVerified.js";
import AdminInterests from "./features/admin/AdminInterests.js";
import AdminPanel from "./features/admin/AdminPanel.js"
import AdminSurveys from "./features/admin/AdminSurveys.js"

import Party from "./features/events/Party";
import Workshops from "./features/events/Workshops";
import Contact from "./pages/Contact";
import Gallery from "./features/events/Gallery";
import EventDetails from "./features/events/EventDetails";
import PartyEventDetails from "./features/events/PartyEventDetails";

import Profile from "./features/user/Profile";
import VerifyEmail from "./features/user/VerifyEmail";
import ForgotPassword from "./features/user/ForgotPassword";
import EditProfile from "./features/user/EditProfile";
import Picnic from "./features/events/Picnic"
import InvitationEventDetails from "./features/events/InvitationEventDetails.js";
// import PostLoginGate from "./pages/PostLoginGate";

import QuestParty from "./features/questionary/QuestParty";
import QuestWorkshops from "./features/questionary/QuestWorkshops.js"
import GuestEventSignup from "./features/events/GuestEventSignup";
import GuestEventSignupSuccess from "./features/events/GuestEventSignupSuccess.js";


import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Events from "./features/events/Events";
import LegalPage from "./pages/LegalPage";

function AppRoutes() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      setTokenGetter(null);
      return;
    }

    setTokenGetter(() =>
      getAccessTokenSilently({
        authorizationParams: { audience: "https://someet-api" },
      })
    );
  }, [isAuthenticated, getAccessTokenSilently]);

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route
            path="/login"
            element={
              <GuestOnly>
                <Login />
              </GuestOnly>
            }
          />

          <Route
            path="/registration"
            element={
              <GuestOnly>
                <Register />
              </GuestOnly>
            }
          />

          <Route
            path="/forgot-password"
            element={
              <GuestOnly>
                <ForgotPassword />
              </GuestOnly>
            }
          />

          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/photos" element={<Gallery />} />

          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <RegisterData />
              </ProtectedRoute>
            }
          />

          <Route path="/picnic" element={<Picnic />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/party" element={<Party />} />
          <Route path="/events/girlsmeetings" element={<Workshops />} />
          <Route path="/events/:eventId" element={<EventDetails />} />

          <Route path="/events/:eventId/signup" element={
            <ProtectedAndOnboarded>
              <GuestEventSignup />
            </ProtectedAndOnboarded>
          } />
          <Route path="/events/:eventId/signup/success" element={<GuestEventSignupSuccess />} />

          <Route path="/events/party/:partyCategory" element={<PartyEventDetails />} />

          <Route
            path="/survey"
            element={
              <ProtectedAndOnboarded>
                <QuestParty />
              </ProtectedAndOnboarded>
            }
          />

          <Route path="/verify" element={<VerifyEmail />} />

          <Route
            path="/profile"
            element={
              <ProtectedAndOnboarded>
                <Profile />
              </ProtectedAndOnboarded>
            }
          />
          <Route path="/account-link" element={<AccountLink />} />
          <Route
            path="/account-link/complete"
            element={<AccountLinkComplete />}
          />

          <Route
            path="/profile/edit"
            element={
              <ProtectedAndOnboarded>
                <EditProfile />
              </ProtectedAndOnboarded>
            }
          />

          <Route
            path="/email-verified"
            element={<EmailVerified />}
          />
          <Route
            path="/admin"
            element={<AdminPanel />}
          >
            <Route
              path="interests"
              element={<AdminInterests />}
            />

            <Route
              path="surveys"
              element={<AdminSurveys />}
            />
          </Route>
          <Route path="/my-invitations/:invitationId" element={<InvitationEventDetails />} />
          <Route path="//workshop-survey" element={<QuestWorkshops />} />
          <Route path="/privacy-policy" element={<LegalPage docType="privacy" />} />
          <Route path="/terms" element={<LegalPage docType="terms" />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default AppRoutes;
